import axios from 'axios'
import * as accessTokenInfo from "../../accessToken";
import router from '../../../router'

export const fetchExpenseJournalList = ({commit, dispatch}, payload) => {
    commit('toggleLoadingState', true)
    if(payload.store_list.length === 0) {
        return false
    } else {
        axios.post('/expenseJournal/index.php', payload, accessTokenInfo.accessTokenInfo())
        .then(res => {
            if(res.data.try_again) {
                dispatch('fetchExpenseJournalList', payload)
            } else {
                commit('setExpenseJournalList', {response: res.data.response, total: res.data.total, page_number: res.data.page_number, page_number: res.data.page_number})
            }
        })
        .catch(error => {
            commit('displayMessageAlert', {message: error, type: 'Error'})
        })
        .finally( () => {
            commit('toggleLoadingState', false)
        })
    }
}

export const emailExpenseJournalList = ({commit, dispatch}, payload) => {
    commit('toggleLoadingState', true)
    setTimeout(() => {
        commit('displayMessageAlert', {message: 'Admin will receive an email in a few minutes.', type: 'Info'})
        commit('toggleLoadingState', false)
    }, 1000);
    
    axios.post('/expenseJournal/emailList.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        console.log(JSON.stringify(res.data))
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
    
}

export const fetchExpenseJournalData = ({commit, dispatch}, payload) => {
    commit('toggleLoadingState', true)
    axios.post('/expenseJournal/single.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            if(payload.copy) {
                res.data.response.id = 0
                commit('displaySuccessNotification', {message: 'Data copied!!!'});                
            }
            
            commit('setExpenseJournalData', {response: res.data.response, copy: payload.copy})   
            dispatch('fetchDocumentList', {account_journal_id: payload.id, copy: payload.copy})     
            
            if(payload.navigate) {
                router.push(router.currentRoute.fullPath+'/form/')
            }

        } else {
            commit('resetExpenseJournalData')
        }
        dispatch('fetchTaxSetting')

    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const submitExpenseJournalData = ({commit}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/expenseJournal/save.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        

        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data submitted successfully!!!'});
            if(payload.id === 0 && !payload.group_add) {
                router.push(router.currentRoute.fullPath.replace('/form/', ''))
            }
            
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const deleteExpenseJournalData = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/expenseJournal/delete.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data deleted successfully!!!'});
            if(payload.navBack) {
                router.push(router.currentRoute.fullPath.replace('/form/', ''))
            } else {
                dispatch('fetchExpenseJournalList', payload.list)
            }
            
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const prepareExpenseSheet = ({commit}, payload) => {

    commit('toggleLoadingState', true)

    axios.post('/exportModule/expense/prepareSheet.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {

        commit('setExportExpenseData', res.data)

    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}


// WEBPACK FOOTER //
// ./src/store/modules/expenseJournal/actions.js